// Mega menu close button functionality
document.addEventListener('click', function(event) {
  const closeButton = event.target.closest('.mega-menu__close-button');
  
  if (closeButton) {
    const detailsElement = closeButton.closest('details');
    if (detailsElement) {
      detailsElement.removeAttribute('open');
      detailsElement.dispatchEvent(new Event('toggle', { bubbles: true }));
      
      const summary = detailsElement.querySelector('summary');
      if (summary) {
        summary.focus();
      }
    }
  }
});